import { render, staticRenderFns } from "./OrgGao.vue?vue&type=template&id=8936e398&scoped=true&"
import script from "./OrgGao.vue?vue&type=script&lang=js&"
export * from "./OrgGao.vue?vue&type=script&lang=js&"
import style0 from "./OrgGao.vue?vue&type=style&index=0&id=8936e398&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8936e398",
  null
  
)

export default component.exports